/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "be4414be8cbaf771a6da51715bdddf2c8573707a";
